import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

export { sidePadding } from "Payments/PaymentPage//Shared/style.js";

export const LeadText = styled.div`
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 400;
  color: #767676;
  text-align: center;
`;

export const SectionContent = styled.div`
  box-shadow: 0 8px 24px 0 #eeeeeeff, 0 4px 8px 0 #42474c0f, 0 0 1px 0 #42474c52;
  border-radius: 14px;
  background: #fff;
  padding: 14px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
`;

export const NextButtonContainer = ({ children, show }) => (
  <AnimatePresence>
    {show && (
      <NextButtonWrapper
        exit={{ height: 0, overflow: "hidden", opacity: 0, scale: 0.9 }}
        key={0}
      >
        <NextButtonPadding />
        {children}
      </NextButtonWrapper>
    )}
  </AnimatePresence>
);

const NextButtonWrapper = styled(motion.div)`
  height: auto;
`;
const NextButtonPadding = styled.div`
  height: 14px;
`;

export const WrapperVerticalPadding = styled.div`
  height: 20px;
`;

export const SectionIconWrapper = styled.div`
  width: 60px;
  flex-shrink: 0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-radius: 6px;
  font-size: 32px;
  margin-right: 14px;
  align-self: flex-start;
  background: #98a4a5;
  position: relative;
  transition: background 0.4s;
  overflow: hidden;
`;

export const pageWidth = "width: min(420px, calc(100vw - 24px));";
